import React from "react";
import PropTypes from "prop-types";
import BaseBlock from "./BaseBlock";
import useBlockData from "./useBlockData";
import FlexTable from "../../../components/ui-components/FlexTable";
import { fmtEur, fmtDate } from "./format";

const columns = [
  { Header: "Title", accessor: "title" },
  { Header: "Owner", accessor: "owner", Cell: ({ value }) => value || "—" },
  { Header: "Potential saving", accessor: "potentialSaving", align: "right", Cell: ({ value }) => fmtEur(value) },
  { Header: "Target", accessor: "targetDate", Cell: ({ value }) => fmtDate(value) },
];

/**
 * OpenOpportunitiesTableBlock - Page 3's not-yet-committed opportunities
 * (open_opportunities_table block type).
 *
 * GET /api/v1/board-reports/{boardReportId}/runs/{runId}/figures/open-opportunities ->
 * envelope key "open_opportunities" -> boardfigures.OpenOpportunities { rows:
 * [OpportunityRow], total: {potentialSaving} } (internal/boardfigures/savings.go's
 * BuildOpenOpportunities), status=potential items sorted potentialSaving desc. Money is
 * EUR float (fmtEur direct, no ÷100).
 */
const OpenOpportunitiesTableBlock = ({ title = "Potential savings", boardReportId, runId }) => {
  const { data, isLoading, error } = useBlockData(
    `/api/v1/board-reports/${boardReportId}/runs/${runId}/figures/open-opportunities`
  );

  const rows = data?.open_opportunities?.rows ?? [];
  const total = data?.open_opportunities?.total ?? null;

  return (
    <BaseBlock title={title} isLoading={isLoading} error={error} className="a4-open-opportunities">
      {rows.length > 0 ? (
        <>
          <FlexTable columns={columns} data={rows} getRowId={(row) => row.id} />
          {total && (
            <div
              className="a4-opportunities-total"
              style={{ marginTop: "3mm", textAlign: "right", fontSize: "9.5pt", fontWeight: 600 }}
            >
              Total potential savings: {fmtEur(total.potentialSaving)}
            </div>
          )}
        </>
      ) : (
        // No potential-status items: a calm note instead of bare column headers (FlexTable
        // always draws its header group even with zero data rows).
        <p className="a4-empty-note" style={{ color: "#6b6b6b", fontSize: "9pt", margin: "2mm 0" }}>
          No open savings opportunities identified.
        </p>
      )}
    </BaseBlock>
  );
};

OpenOpportunitiesTableBlock.propTypes = {
  title: PropTypes.string,
  boardReportId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  runId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default OpenOpportunitiesTableBlock;
